import { FieldPath, FieldValues, useController } from "react-hook-form";
import { FormFieldError } from "../FormFieldError";
import { Input } from "../inputs/Input";
import { FormInputProps } from "./FormInput";

export const FormSSN = <TFieldValues extends FieldValues, TTransformedValues = TFieldValues>({
	name,
	control,
	defaultValue,
	compact,
	className,
	containerClassName,
	placeholder,
	disabled,
	errorMessage,
	testId,
}: FormInputProps<TFieldValues, TTransformedValues>) => {
	const {
		field,
		fieldState: { error },
	} = useController<TFieldValues, FieldPath<TFieldValues>, TTransformedValues>({
		name,
		control,
		defaultValue,
	});

	const displayValue = field.value ?? "";
	const hasError = !!error;

	return (
		<div className="relative">
			<Input
				{...field}
				value={displayValue}
				onChange={(e) => {
					const value = e.target.value.replace(/\D/g, "").slice(0, 9);
					field.onChange(value === "" ? null : value);
				}}
				compact={compact}
				className={className}
				containerClassName={containerClassName}
				placeholder={placeholder}
				disabled={disabled}
				type="text"
				inputMode="numeric"
				error={hasError}
				testId={testId}
			/>
			{hasError && <FormFieldError error={error} errorMessage={errorMessage} />}
		</div>
	);
};
